import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { ICON_MAP } from '@shared/constants/toast';

@Component({
  selector: 'app-inline-message',
  imports: [CommonModule, MatIconModule],
  templateUrl: './inline-message.component.html',
  styleUrl: './inline-message.component.scss'
})
export class InlineMessageComponent {
  @Input() type = '';
  @Input() title = '';
  @Input() description = '';
  @Input() note = '';
  iconMap = ICON_MAP;
  get icon(): string {
    return this.iconMap[this.type] || 'info';
  }
}
